import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Alert, AlertDescription } from '../../components/ui/alert';
import { useAuth } from '../../contexts/AuthContext';
import { fetchPaymentSettings, savePaymentSettings } from '../../services/site';

const PaymentSettings = () => {
  const { user, token } = useAuth();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [form, setForm] = useState({ member_monthly_amount: '', supporter_monthly_amount: '' });

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        const data = await fetchPaymentSettings(token);
        setForm({
          member_monthly_amount: data.member_monthly_amount ?? '',
          supporter_monthly_amount: data.supporter_monthly_amount ?? ''
        });
      } catch (e) {
        setError(e.response?.data?.detail || e.message);
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  if (!user || user.user_type !== 'fondateur') {
    return <div className="p-6 text-sm text-red-500">Accès réservé au fondateur.</div>;
  }

  const onSave = async () => {
    try {
      setSaving(true); setError(''); setSuccess('');
      const payload = {
        id: 'payment_settings',
        member_monthly_amount: form.member_monthly_amount !== '' ? Number(form.member_monthly_amount) : null,
        supporter_monthly_amount: form.supporter_monthly_amount !== '' ? Number(form.supporter_monthly_amount) : null
      };
      await savePaymentSettings(payload, token);
      setSuccess('✅ Prix mis à jour. Ils s\'appliqueront aux paiements V1/V2.');
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6">
      <Card>
        <CardHeader>
          <CardTitle>Tarifs des Adhésions</CardTitle>
          <CardDescription>Modifiez les montants Membre et Supporter. S\'applique aux paiements (Stripe V1/V2).</CardDescription>
        </CardHeader>
        <CardContent>
          {error && <Alert><AlertDescription className="text-red-600">{error}</AlertDescription></Alert>}
          {success && <Alert><AlertDescription className="text-green-600">{success}</AlertDescription></Alert>}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm mb-1">Adhésion Membre (€/mois)</label>
              <input data-testid="member-monthly-amount-input" type="number" step="0.01" className="w-full rounded-md border border-border bg-background px-3 py-2" value={form.member_monthly_amount} onChange={e => setForm({ ...form, member_monthly_amount: e.target.value })} />
            </div>
            <div>
              <label className="block text-sm mb-1">Adhésion Supporter (€/mois)</label>
              <input data-testid="supporter-monthly-amount-input" type="number" step="0.01" className="w-full rounded-md border border-border bg-background px-3 py-2" value={form.supporter_monthly_amount} onChange={e => setForm({ ...form, supporter_monthly_amount: e.target.value })} />
            </div>
          </div>

          <div className="flex justify-end mt-4">
            <Button data-testid="save-payment-settings-btn" onClick={onSave} disabled={saving}>{saving ? 'Enregistrement…' : 'Sauvegarder les prix'}</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSettings;